import { getUserId } from '../../../../DefaultService';
import { IPaginationParams } from '../../../../types';
import { useQuery } from 'react-query';
import { ISportHallFilterParams } from '../../types';
import {
  getSportHallsByLicenseAsync,
  getSportHallsByLicenseCountAsync,
} from '../../index';

const USER_ID = getUserId();

export const useGetAllSportHallsByLicenseAsync = (
  pagination: IPaginationParams,
  filter: ISportHallFilterParams,
) =>
  useQuery([`sportHalls${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getSportHallsByLicenseAsync(pagination, filter),
  });

export const useGetSportHallsByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: ISportHallFilterParams,
) =>
  useQuery([`sportHallsCount${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getSportHallsByLicenseCountAsync(filter),
  });
